import { toast } from "react-hot-toast";
import Notify from "../../components/Notify";

export function Notification(status: string, message: string) {
  return toast.custom(
    (t) => <Notify t={t} message={message} status={status} />,
    { position: "top-right", id: "nc-product-notify", duration: 3000 }
  );
}
